import queries from '@apis/queries';
import Button from '@components/Button';
import Column from '@components/Column';
import PrepaidContext from '@components/prepaid/PrepaidProvider/PrepaidContext';
import Row from '@components/Row';
import Text from '@components/Text';
import colors from '@constants/colors';
import { useQuery } from '@tanstack/react-query';
import { useContext } from 'react';
import { useTranslation } from 'react-i18next';

import usePrepaidCharge from './hooks/usePrepaidCharge';

interface Props {
    id: string;
}

function PrepaidCardChargeFooter({ id }:Props) {
    const { t } = useTranslation('prepaidCard');
    const { amount } = useContext(PrepaidContext);
    const { data } = useQuery(queries.userPrepaidCard.detail(id));
    const { handleCharge } = usePrepaidCharge(id);
    return (
        <Column fullWidth spacing={16}>
            <Column fullWidth spacing={8}>
                <Row fullWidth justify='space-between'>
                    <Text color={colors.gray6}
                        size='lg'
                        fontWeight='bold'>{t('charge.currentBalance')}</Text>
                    <Text size='lg'>{data?.balance.toLocaleString()}{t('currencyUnit')} </Text>
                </Row>
                <Row fullWidth justify='space-between'>
                    <Text color={colors.gray6}
                        size='lg'
                        fontWeight='bold'>{t('charge.chargeAmount')}</Text>
                    <Text size='lg'>+{(amount * 10000).toLocaleString()}{t('currencyUnit')}  </Text>
                </Row>
                <Row fullWidth justify='space-between'>
                    <Text size='xl'
                        fontWeight='bold'>{t('charge.afterChargeAmount')}</Text>
                    <Text size='3xl'
                        color={colors.red}
                        fontWeight='bold'>
                        {(amount * 10000 + (data?.balance || 0)).toLocaleString()}{t('currencyUnit')}
                    </Text>
                </Row>
            </Column>
            <Button fullWidth onClick={handleCharge}>
                {t('charge.payment')}
            </Button>
        </Column>
    );
}

export default PrepaidCardChargeFooter;
